import React, { useState } from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import { StyledTagsInputWrapper } from './StyledTagsInputWrapper';
import { Text } from '../';

const TagsInput = ({
  tags = [],
  onTagsChange,
  label,
  placeholder = 'برچست ها را با enter از هم جدا کنید.',
  limit = 10,
}) => {
  const [_placeholder, setPlaceHolder] = useState(placeholder);

  const handleTagDeletion = (i) => {
    const _tags = tags.filter((t, index) => index !== i);
    onTagsChange(_tags);
  };

  const handleTagAddition = (tag) => {
    if (tags.length < limit) {
      const _tags = [...tags, tag];
      onTagsChange(_tags);
    } else {
      setPlaceHolder(`بیشتر از ${limit} مورد نمیتوانید وارد کنید !!`);
    }
  };

  return (
    <>
      {label && (
        <Text type="h5" size="mdb" color="black" className="mb-2">
          {label}
        </Text>
      )}
      <StyledTagsInputWrapper>
        <ReactTags
          tags={tags}
          placeholder={_placeholder}
          handleDelete={handleTagDeletion}
          handleAddition={handleTagAddition}
          handleDrag={() => {}}
          inputFieldPosition="top"
          allowDragDrop={false}
          allowUnique={false}
          allowDeleteFromEmptyInput={false}
        />
      </StyledTagsInputWrapper>
    </>
  );
};

export default TagsInput;
